/**
 * Global API error handler. Set from the app (inside NotificationsProvider)
 * so that unhandled 5xx errors show a user-facing toast.
 */
type ApiErrorHandler = (message: string) => void;

let globalHandler: ApiErrorHandler | null = null;

export function setGlobalApiErrorHandler(handler: ApiErrorHandler | null): void {
  globalHandler = handler;
}

export function notifyApiError(message: string): void {
  globalHandler?.(message);
}
